<template>
  <div id="qrcode" ref="qrCodeDiv"></div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  export default {
    name: "qrcode",
    props:['id',"identifyCard","ticketDate"],
    data() {
      return {
        uid:this.id,
        url:'',
        idCard:this.identifyCard,
        date:this.ticketDate,
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.bindQRCode();
      })
    },
    methods: {
      bindQRCode: function () {
        var url = window.location.origin + window.location.pathname;
        new QRCode(this.$refs.qrCodeDiv, {
          text: this.idCard === undefined?url:this.idCard + '&'+ this.date,
          width: this.idCard === undefined?80:160,
          height: this.idCard === undefined?80:160,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L,//容错率，L/M/H
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/qrCode/qrCode.vue